export default "__VITE_ASSET__4fcdb0d8__"